module.exports = __webpack_public_path__ + "img/com.codeway.routease.463a8977.png";